module.exports = __webpack_public_path__ + "static/img/1 -2.7e5f5791.jpg";